import { ApiContentSection, ApiSectionType } from '@storefronts/common-types'
import { SECONDARY_FONT_CSS_VAR } from '../../../context/CustomizationContextProvider'
import { scaledFontSize, ScrollingLayout } from '../../../style/scrollingLayout'
import { getTypographyRoleStyle } from '../../../style/typography'
import { TYPOGRAPHY_SIZE } from '../../../style/typographySizes'
import { SectionContainer } from './Shared'

type HeaderSection = Extract<
    ApiContentSection,
    { type: ApiSectionType.HEADER_TEXT }
>

export const HeaderText: React.FC<{ section: HeaderSection }> = ({
    section,
}) => {
    if (section.text.length == 0) return null

    return (
        <SectionContainer maxContentWidth={ScrollingLayout.PROSE_MAX_WIDTH}>
            <h1
                style={{
                    // Page hero header – dedicated hero H1
                    ...getTypographyRoleStyle('displayHeading', {
                        fontFamily: `var(${SECONDARY_FONT_CSS_VAR})`,
                        fontWeight: 500,
                        lineHeight: 1.25,
                    }),
                    fontSize: scaledFontSize(TYPOGRAPHY_SIZE.DISPLAY),
                    color: 'var(--primary-color)',
                    textAlign: 'center',
                }}
            >
                {section.text}
            </h1>
        </SectionContainer>
    )
}
